"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var interfaces_1 = require("../interfaces");
var constants_1 = require("../../../constants");
var index_1 = require("./index");
var defaultToggleBrands = [
    {
        title: constants_1.TRADE_IN_TITLES.SUZUKI,
        value: interfaces_1.VehicleBrands.suzuki,
        price: 100000,
    },
    {
        title: constants_1.TRADE_IN_TITLES.OTHER,
        value: interfaces_1.VehicleBrands.other,
        price: 80000,
    }
];
var ToggleBrand = /** @class */ (function (_super) {
    __extends(ToggleBrand, _super);
    function ToggleBrand(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.state = {
            activeBrand: (_a = props.defaultBrand) !== null && _a !== void 0 ? _a : '',
        };
        _this.toggleBrandHandler = _this.toggleBrandHandler.bind(_this);
        return _this;
    }
    ToggleBrand.prototype.toggleBrandHandler = function (value) {
        var _this = this;
        var onChangeBrand = this.props.onChangeBrand;
        this.setState({
            activeBrand: value,
        }, function () {
            if (onChangeBrand) {
                onChangeBrand(_this.state.activeBrand);
            }
        });
    };
    ToggleBrand.prototype.render = function () {
        var _this = this;
        var brands = this.props.brands;
        var activeBrand = this.state.activeBrand;
        return (React.createElement("div", { className: "tradein-toggle-brand" },
            React.createElement("div", { className: "tradein-toggle-brand__list" }, brands.map(function (brand) {
                return React.createElement(index_1.ToggleBrandItem, { key: brand.value, brand: brand, active: brand.value === activeBrand, onClick: _this.toggleBrandHandler });
            }))));
    };
    ToggleBrand.defaultProps = {
        brands: defaultToggleBrands,
    };
    return ToggleBrand;
}(React.PureComponent));
exports.default = ToggleBrand;
